import { mapValues } from 'radash';
import '../tokens/border-radiuses.js';
import { colors } from '../tokens/colors.js';
import '../tokens/font-sizes.js';
import '../tokens/gaps.js';
import '../tokens/heights.js';
import '../tokens/spacings.js';
import '../tokens/widths.js';

/**
 * The mapping between fill color tones and stroke color tones for dark mode.
 */ const darkModeMapping = {
    none: 'none',
    soft: 'weak',
    medium: 'medium',
    bold: 'strong'
};
/**
 * A mapping between fill colors and fill color tones to stroke color tones, aiding in the outlining
 * of elements for visual distinction.
 */ const fillToOutlineColorTone = {
    light: {
        base: {
            none: 'none',
            soft: 'weak',
            medium: 'weak',
            bold: 'weak'
        },
        ...mapValues(colors, ()=>({
                none: 'none',
                soft: 'none',
                medium: 'none',
                bold: 'none'
            }))
    },
    dark: {
        base: darkModeMapping,
        ...mapValues(colors, ()=>darkModeMapping)
    }
};

export { fillToOutlineColorTone };
//# sourceMappingURL=fill-to-outline-color-tone.js.map
